import { render, staticRenderFns } from "./companyClassify.vue?vue&type=template&id=2e5df630&scoped=true"
import script from "./companyClassify.vue?vue&type=script&lang=js"
export * from "./companyClassify.vue?vue&type=script&lang=js"
import style0 from "./companyClassify.vue?vue&type=style&index=0&id=2e5df630&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e5df630",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\work\\git-new\\ai-business-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2e5df630')) {
      api.createRecord('2e5df630', component.options)
    } else {
      api.reload('2e5df630', component.options)
    }
    module.hot.accept("./companyClassify.vue?vue&type=template&id=2e5df630&scoped=true", function () {
      api.rerender('2e5df630', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/industryChainNew/components/companyClassify.vue"
export default component.exports